// Pages/ProductModal.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProductDetails from "../Components/ProductDetails";

export default function ProductModal() {
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const ANIM_DURATION = 220; // ms - keep in sync with CSS

  useEffect(() => {
    // Trigger enter animation on mount
    const t = setTimeout(() => setIsOpen(true), 10);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    // trigger exit animation then navigate back
    setIsOpen(false);
    setTimeout(() => navigate(-1), ANIM_DURATION);
  };

  return (
    <div
      className={"product-modal-backdrop" + (isOpen ? " open" : "")}
      onClick={close}
    >
      <div
        className={"product-modal" + (isOpen ? " open" : "")}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <button className="modal-close" onClick={close} aria-label="Close">✕</button>

        <ProductDetails layout="modal" />
      </div>
    </div>
  );
}
